(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1618],{

/***/ 59325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _react2.default.createContext(function () {
  throw new Error('Message provider is not mounted');
});

/***/ }),

/***/ 52945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(88077), __esModule: true };

/***/ }),

/***/ 88239:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(52945);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports["default"] = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 88077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

__webpack_require__(80529);
module.exports = __webpack_require__(94731).Object.assign;


/***/ }),

/***/ 50266:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(95810);
var getKeys = __webpack_require__(99656);
var gOPS = __webpack_require__(32614);
var pIE = __webpack_require__(43416);
var toObject = __webpack_require__(19411);
var IObject = __webpack_require__(72312);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(93777)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 80529:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(49901);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(50266) });


/***/ }),

/***/ 97387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));


/***/ }),

/***/ 32321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getDeviceId; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54501);
/* harmony import */ var _packages_justo_parts_lib_helpers_getQueryParam__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43621);
/* harmony import */ var _misc_generateId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6882);




function getDeviceId() {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return null;
    var paramDeviceId = (0,_packages_justo_parts_lib_helpers_getQueryParam__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("deviceId");
    if (paramDeviceId) {
        localStorage.setItem("deviceId", paramDeviceId);
        return paramDeviceId;
    }
    var savedId = (0,_hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__/* .localStorageGetItem */ .G)("deviceId");
    if (savedId) return savedId;
    var generatedId = (0,_misc_generateId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(50);
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("deviceId", generatedId);
    return generatedId;
};


/***/ }),

/***/ 70457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28734);
/* harmony import */ var dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10285);
/* harmony import */ var dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96036);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56176);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var dayjs_locale_es__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67763);
/* harmony import */ var dayjs_locale_es__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(dayjs_locale_es__WEBPACK_IMPORTED_MODULE_8__);






 // dependent on utc plugin


dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_advancedFormat__WEBPACK_IMPORTED_MODULE_1___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_7___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_6___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_0___default().extend((dayjs_plugin_customParseFormat__WEBPACK_IMPORTED_MODULE_2___default()));
// To detect the locale dynamically, we would need to add a babel-preset to
// allow dynamic imports, where in line 7 _es_ is a variable. For the time
// being I think it's better to leave it as it is, because there is still
// consideration towards going back to CRA as a bundler, and it doesn't allow a
// .babelrc config.
// I don't think differenciating between es locales makes sense, as this will
// be used to translate months, name of week days, etc.
dayjs__WEBPACK_IMPORTED_MODULE_0___default().locale("es");
/* harmony default export */ __webpack_exports__["Z"] = ((dayjs__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ 80251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logger; }
});

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
// EXTERNAL MODULE: ./node_modules/@sentry/types/esm/severity.js
var severity = __webpack_require__(13819);
;// CONCATENATED MODULE: ./src/helpers/logger/JustoError.ts
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent1, args1, Class1) {
    if (isNativeReflectConstruct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _wrapNativeSuper(Class2) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class2);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var JustoError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(JustoError, Error1);
    var _super = _createSuper(JustoError);
    function JustoError(errMessage, data) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "error";
        _classCallCheck(this, JustoError);
        var _this;
        _this = _super.call(this, errMessage);
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_assertThisInitialized(_this), JustoError);
        }
        _this.name = "JustoError";
        return _this;
    }
    return JustoError;
}(_wrapNativeSuper(Error));


;// CONCATENATED MODULE: ./src/helpers/logger/transports.ts


var logException = function(exception) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureException = param.captureException;
        captureException(exception, {
            tags: {
                errorLevel: "JustoException"
            },
            level: severity/* Severity.Error */.z.Error,
            extra: data
        });
        console.error("Justo<exception>", exception, data);
    });
};
var logError = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureException = param.captureException;
        captureException(new JustoError(message, data), {
            tags: {
                errorLevel: "JustoError"
            },
            level: severity/* Severity.Error */.z.Error,
            extra: data
        });
        console.error("Justo<error>", message, data);
    });
};
var logWarn = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39666)).then(function(param) {
        var captureMessage = param.captureMessage;
        captureMessage(new JustoError(message, data, "warning").message, {
            tags: {
                errorLevel: "JustoWarning"
            },
            level: severity/* Severity.Warning */.z.Warning,
            extra: data
        });
        console.warn("Justo<warn>", message, data);
    });
};
var logDebug = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.log("Justo<debug>", message, data);
    console.trace();
};
var logInfo = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.info("Justo<info>", message, data);
};
var log = function(message) {
    var data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    console.info("Justo<log>", message, data);
    console.trace();
};
var envConfig = {
    local: {
        exception: logInfo,
        error: log,
        warn: log,
        info: logInfo,
        debug: logDebug
    },
    prod: {
        exception: logException,
        error: logError,
        warn: logWarn,
        info: logInfo,
        debug: logDebug
    },
    dev: {
        exception: logException,
        error: logError,
        warn: logWarn,
        info: logInfo,
        debug: logDebug
    }
};
/* harmony default export */ var transports = (envConfig);

;// CONCATENATED MODULE: ./src/helpers/logger/index.ts


/* harmony default export */ var logger = (transports[(0,getEnv/* default */.Z)()]);


/***/ }),

/***/ 55879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCurrentMainDomain; }
/* harmony export */ });
/* harmony import */ var _isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);
/* provided dependency */ var process = __webpack_require__(34155);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var mainDomains = [
    "localhost",
    "getjusto.com",
    "bejusto.com",
    "local",
    "orioneat.com",
    "orioneats.com"
].concat(_toConsumableArray(process.env.REACT_APP_DOMAIN ? [
    process.env.REACT_APP_DOMAIN
] : []));
function getCurrentMainDomain() {
    if ((0,_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return null;
    return mainDomains.find(function(domain) {
        return String(window.location.hostname) === domain || String(window.location.hostname).endsWith(".".concat(domain));
    });
};


/***/ }),

/***/ 54142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ isMainDomain; }
});

// EXTERNAL MODULE: ./src/helpers/misc/domain/getCurrentMainDomain.ts
var getCurrentMainDomain = __webpack_require__(55879);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/helpers/misc/domain/getSubdomain.ts


function getSubdomain() {
    if ((0,isServerSide/* default */.Z)()) return null;
    return String(window.location.hostname).slice(0, -((0,getCurrentMainDomain/* default */.Z)().length + 1));
};

;// CONCATENATED MODULE: ./src/helpers/misc/domain/isInSubdomain.ts


function isInSubdomain() {
    for(var _len = arguments.length, subdomains = new Array(_len), _key = 0; _key < _len; _key++){
        subdomains[_key] = arguments[_key];
    }
    return !!(0,getCurrentMainDomain/* default */.Z)() && subdomains.includes(getSubdomain());
};

;// CONCATENATED MODULE: ./src/helpers/misc/domain/isMainDomain.ts

function isMainDomain() {
    return isInSubdomain("web", "www", "support", "");
};


/***/ }),

/***/ 6882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GenerateId; }
/* harmony export */ });
var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
function GenerateId() {
    var length = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 24;
    var text = "";
    for(var i = 0; i < length; i++){
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
};


/***/ }),

/***/ 90257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isServerSide; }
/* harmony export */ });
function isServerSide() {
    return "object" === "undefined";
};


/***/ }),

/***/ 54501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ localStorageGetItem; },
/* harmony export */   "Z": function() { return /* binding */ useLocalStorageState; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80251);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90257);
/* harmony import */ var _providers_GlobalState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91733);




var getSavedValue = function getSavedValue(key, defaultValue) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) return defaultValue;
    if (!localStorage) return defaultValue;
    var savedValue = localStorageGetItem(key, null);
    if (savedValue === null) {
        return defaultValue;
    } else {
        try {
            return JSON.parse(savedValue);
        } catch (error) {
            _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error(error);
            return defaultValue;
        }
    }
};
function useLocalStorageState(key, defaultValue) {
    var value = getSavedValue(key, defaultValue);
    var forceUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_GlobalState__WEBPACK_IMPORTED_MODULE_2__/* .Context */ ._);
    var setValue = function(newValue) {
        localStorage.setItem(key, JSON.stringify(newValue));
        forceUpdate();
    };
    return [
        value,
        setValue
    ];
};
function localStorageGetItem(key, valueOnError) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) return valueOnError;
    if (!localStorage) return valueOnError;
    try {
        var value = localStorage.getItem(key);
        return value;
    } catch (error) {
        _helpers_logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"].error */ .Z.error("Error getting local storage", error);
        return valueOnError;
    }
}


/***/ }),

/***/ 11612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSessionStorageState; },
/* harmony export */   "z": function() { return /* binding */ getSavedValue; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_GlobalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91733);



var getSavedValue = function getSavedValue(key, defaultValue) {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)()) return defaultValue;
    var savedValue = sessionStorage.getItem(key);
    if (savedValue === null) {
        return defaultValue;
    } else {
        return JSON.parse(savedValue);
    }
};
function useSessionStorageState(key, defaultValue) {
    var value = getSavedValue(key, defaultValue);
    var forceUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_GlobalState__WEBPACK_IMPORTED_MODULE_1__/* .Context */ ._);
    var setValue = function(newValue) {
        sessionStorage.setItem(key, JSON.stringify(newValue));
        forceUpdate();
    };
    return [
        value,
        setValue
    ];
};


/***/ }),

/***/ 91733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ Context; },
  "q": function() { return /* binding */ GlobalState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useForceUpdate.ts

var max = 9007199254740990;
function useForceUpdate() {
    var ref = (0,react.useState)(0), setState = ref[1];
    var forceUpdate = function() {
        return setState(function(state) {
            return (state + 1) % max;
        });
    };
    return forceUpdate;
};

;// CONCATENATED MODULE: ./src/providers/GlobalState.tsx



var Context = /*#__PURE__*/ react.createContext(null);
function GlobalState(props) {
    var forceUpdate = useForceUpdate();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Context.Provider, {
        value: forceUpdate,
        children: props.children
    });
}



/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 7381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Root; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Provider/Message.js
var Message = __webpack_require__(36912);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/context/ApolloProvider.js
var ApolloProvider = __webpack_require__(53768);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./src/providers/apollo/getClients.ts + 6 modules
var getClients = __webpack_require__(52629);
;// CONCATENATED MODULE: ./src/providers/apollo/ApolloServicesClients.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


 // Used inside AutoForm


function ApolloServicesClients(props) {
    var clients = (0,getClients/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(apollo_hooks_es/* ApolloProvider */.eT, _objectSpread({}, clients, {
        client: clients.main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloProvider/* ApolloProvider */.e, {
            client: clients.main,
            children: props.children
        })
    }));
};

// EXTERNAL MODULE: ./src/providers/GlobalState.tsx + 1 modules
var GlobalState = __webpack_require__(91733);
// EXTERNAL MODULE: ./src/providers/MobileOrDesktopContext.ts
var MobileOrDesktopContext = __webpack_require__(95078);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/useOnEvent.js
var useOnEvent = __webpack_require__(80967);
// EXTERNAL MODULE: ./src/helpers/auth/SessionContext.ts
var SessionContext = __webpack_require__(97387);
// EXTERNAL MODULE: ./src/providers/apollo/getJWTSavedData.ts
var getJWTSavedData = __webpack_require__(43859);
;// CONCATENATED MODULE: ./src/providers/Session.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}






function SessionContextProvider(props) {
    var jwtData = (0,getJWTSavedData/* default */.Z)();
    var ref = (0,react.useState)(jwtData), session = ref[0], setSession = ref[1];
    (0,useOnEvent["default"])("saveSession", function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(newSession) {
            var setUserId;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setSession(newSession);
                        if (!newSession) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 4;
                        return Promise.all(/* import() */[__webpack_require__.e(8821), __webpack_require__.e(2860)]).then(__webpack_require__.bind(__webpack_require__, 52860));
                    case 4:
                        setUserId = _ctx.sent.setUserId;
                        setUserId(newSession.userId);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(newSession) {
            return _ref.apply(this, arguments);
        };
    }());
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SessionContext/* default.Provider */.Z.Provider, {
        value: session || {},
        children: props.children
    });
};

// EXTERNAL MODULE: ./src/providers/WebsiteIdContext.ts
var WebsiteIdContext = __webpack_require__(70880);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/providers/locale.ts


__webpack_require__.g.numeral = (numeral_default());
__webpack_require__.g.dayjs = (dayjs_min_default());

;// CONCATENATED MODULE: ./src/providers/Root/index.tsx










var NonSsrRoot = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3969).then(__webpack_require__.bind(__webpack_require__, 93969));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93969)
            ];
        }
    },
    ssr: false
});
function Root(param) {
    var children = param.children, websiteId = param.websiteId, mobileOrDesktop = param.mobileOrDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ApolloServicesClients, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalState/* GlobalState */.q, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktopContext/* default.Provider */.Z.Provider, {
                value: mobileOrDesktop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebsiteIdContext/* default.Provider */.Z.Provider, {
                    value: websiteId,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message["default"], {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SessionContextProvider, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NonSsrRoot, {}),
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 70880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var WebsiteIdContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
WebsiteIdContext.displayName = "WebsiteIdContext";
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteIdContext);


/***/ }),

/***/ 52629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getClients; }
});

// EXTERNAL MODULE: ./src/providers/getEnv.ts
var getEnv = __webpack_require__(4266);
// EXTERNAL MODULE: ./src/providers/services/index.ts
var services = __webpack_require__(46842);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 2 modules
var inMemoryCache = __webpack_require__(18817);
;// CONCATENATED MODULE: ./src/components/WrappedWebsite/constants.ts
var WRAPPED_WEBSITE_ID_KEY = "wrappedWebsiteId";

// EXTERNAL MODULE: ./src/helpers/auth/getDeviceId.ts
var getDeviceId = __webpack_require__(32321);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
;// CONCATENATED MODULE: ./src/helpers/auth/getFingerprint.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var fingerprint = null;
var loadFingerprint = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
        var FingerprintJS, fp, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(0,isServerSide/* default */.Z)()) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return __webpack_require__.e(/* import() */ 2226).then(__webpack_require__.bind(__webpack_require__, 2226));
                case 4:
                    _ctx.next = 6;
                    return _ctx.sent.default;
                case 6:
                    FingerprintJS = _ctx.sent;
                    _ctx.next = 9;
                    return FingerprintJS.load();
                case 9:
                    fp = _ctx.sent;
                    _ctx.next = 12;
                    return fp.get();
                case 12:
                    result = _ctx.sent;
                    fingerprint = result.visitorId;
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function loadFingerprint() {
        return _ref.apply(this, arguments);
    };
}();
setTimeout(function() {
    loadFingerprint();
}, 1);
function getFingerprint() {
    return fingerprint;
};

// EXTERNAL MODULE: ./src/helpers/misc/domain/isMainDomain.ts + 2 modules
var isMainDomain = __webpack_require__(54142);
// EXTERNAL MODULE: ./src/hooks/useLocalStorageState.ts
var useLocalStorageState = __webpack_require__(54501);
;// CONCATENATED MODULE: ./src/helpers/websites/getDomain.ts



function getDomain() {
    if ((0,isServerSide/* default */.Z)()) return null // Only client-side
    ;
    if ((0,isMainDomain/* default */.Z)()) return null;
    if (localStorage && (0,useLocalStorageState/* localStorageGetItem */.G)("salesPointDomain")) {
        return (0,useLocalStorageState/* localStorageGetItem */.G)("salesPointDomain");
    } else {
        return window.location.hostname;
    }
};

// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
// EXTERNAL MODULE: ./node_modules/@orion-js/graphql-client/lib/index.js
var lib = __webpack_require__(61858);
// EXTERNAL MODULE: ./src/providers/url.ts
var url = __webpack_require__(65494);
// EXTERNAL MODULE: ./src/providers/apollo/saveJWT.ts + 1 modules
var saveJWT = __webpack_require__(65160);
;// CONCATENATED MODULE: ./src/providers/apollo/refreshJWT.ts
function refreshJWT_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function refreshJWT_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                refreshJWT_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                refreshJWT_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





function refreshJWT() {
    return _refreshJWT.apply(this, arguments);
};
function _refreshJWT() {
    _refreshJWT = refreshJWT_asyncToGenerator(runtime_default().mark(function _callee() {
        var response, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(0,isServerSide/* default */.Z)()) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    if ((0,useLocalStorageState/* localStorageGetItem */.G)("justo_jwt_refresh")) {
                        _ctx.next = 7;
                        break;
                    }
                    console.log("removing session because no refresh token");
                    _ctx.next = 6;
                    return (0,saveJWT/* default */.Z)({});
                case 6:
                    return _ctx.abrupt("return");
                case 7:
                    _ctx.next = 9;
                    return fetch("".concat(url/* default */.Z, "/auth/refreshToken"), {
                        method: "POST",
                        headers: {
                            "X-ORION-REFRESH": (0,useLocalStorageState/* localStorageGetItem */.G)("justo_jwt_refresh") || null
                        }
                    });
                case 9:
                    response = _ctx.sent;
                    _ctx.next = 12;
                    return response.json();
                case 12:
                    result = _ctx.sent;
                    if (!(result.error || !result.token)) {
                        _ctx.next = 18;
                        break;
                    }
                    console.log("Error refreshing JWT. Will reset Session");
                    _ctx.next = 17;
                    return (0,saveJWT/* default */.Z)({});
                case 17:
                    return _ctx.abrupt("return");
                case 18:
                    _ctx.next = 20;
                    return (0,saveJWT/* default */.Z)({
                        token: result.token
                    });
                case 20:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _refreshJWT.apply(this, arguments);
}

// EXTERNAL MODULE: ./src/helpers/dayjs/index.ts
var dayjs = __webpack_require__(70457);
;// CONCATENATED MODULE: ./src/providers/apollo/createApolloClient/getTimezone.ts

function getTimezone() {
    return dayjs/* default.tz.guess */.Z.tz.guess();
};

;// CONCATENATED MODULE: ./src/providers/apollo/createApolloClient/index.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var windowApolloState = !(0,isServerSide/* default */.Z)() && window.__NEXT_DATA__.apolloState;
function createApolloClient(param) {
    var endpointURL = param.endpointURL, useSubscriptions = param.useSubscriptions;
    // use unique session key per project to avoid
    // loging in and out every time you change it
    // in localhost
    var cache = new inMemoryCache/* InMemoryCache */.h({
        dataIdFromObject: function dataIdFromObject(object) {
            if (object._id) return "".concat(object.__typename, ":").concat(object._id);
            if (object.id) return "".concat(object.__typename, ":").concat(object.id);
            if (object.__typename === "Cart") return "cart";
        },
        typePolicies: {
            // https://www.apollographql.com/docs/react/caching/cache-field-behavior/#merging-non-normalized-objects
            Schedule: {
                merge: true
            },
            Country: {
                merge: true
            },
            WebsiteDesign: {
                merge: true
            },
            ProductAvailability: {
                merge: true
            },
            StoreAddress: {
                merge: true
            },
            MenuSectionConfiguration: {
                merge: true
            },
            Cart: {
                merge: true
            },
            Preference: {
                fields: {
                    cart: {
                        merge: true
                    }
                }
            },
            CouponStatus: {
                merge: true
            }
        }
    }).restore(windowApolloState || {});
    return (0,lib.createClient)({
        ssrMode: (0,isServerSide/* default */.Z)(),
        endpointURL: endpointURL,
        useSubscriptions: useSubscriptions,
        cache: cache,
        batch: false,
        apolloOverrides: {
            // Disable the Apollo cache on the server-side
            // Othwerwise, RAM usage will keep growing on production as the server stores more and more website data.
            defaultOptions: (0,isServerSide/* default */.Z)() ? {
                watchQuery: {
                    fetchPolicy: "no-cache"
                },
                query: {
                    fetchPolicy: "no-cache"
                }
            } : {}
        },
        resolvers: {},
        getHeaders: function getHeaders(body) {
            if ((0,isServerSide/* default */.Z)()) return {};
            var timezone = getTimezone() // TODO: review headers on the server side
            ;
            var storedWebsiteId = (0,useSessionStorageState/* getSavedValue */.z)(WRAPPED_WEBSITE_ID_KEY);
            return _objectSpread({
                "X-ORION-DEVICEID": (0,getDeviceId/* default */.Z)(),
                "X-ORION-FP": getFingerprint(),
                "X-ORION-DOMAIN": getDomain() || "",
                "X-ORION-REFERRER": document.referrer,
                "X-ORION-TIMEZONE": timezone,
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'location' does not exist on type '{ __NE... Remove this comment to see the full error message
                "X-ORION-PATHNAME": window.location.pathname
            }, storedWebsiteId ? {
                "X-ORION-WRAPPED-WEBSITE": storedWebsiteId
            } : {});
        },
        saveSession: function saveSession(session) {},
        getSession: function getSession(session) {
            return {};
        },
        getJWT: function() {
            return (0,isServerSide/* default */.Z)() ? null : (0,useLocalStorageState/* localStorageGetItem */.G)("justo_jwt_token") || null;
        },
        refreshJWT: refreshJWT
    });
};

;// CONCATENATED MODULE: ./src/providers/apollo/getClients.ts



var env = (0,getEnv/* default */.Z)();
var clients = {};
function getClients() {
    if (Object.keys(clients).length > 0) return clients;
    for(var key in services/* default */.Z){
        var service = services/* default */.Z[key];
        var urls = service.urls;
        var url = urls[env];
        clients[key] = createApolloClient({
            endpointURL: url,
            useSubscriptions: service.useSubscriptions
        });
    }
    return clients;
};


/***/ }),

/***/ 43859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getJWTSavedData; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90257);
/* harmony import */ var _hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54501);


function getJWTSavedData() {
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()) return {};
    try {
        return JSON.parse((0,_hooks_useLocalStorageState__WEBPACK_IMPORTED_MODULE_0__/* .localStorageGetItem */ .G)("justo_jwt_data")) || {};
    } catch (error) {
        return {};
    }
};


/***/ }),

/***/ 93307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ onSessionSaved; }
/* harmony export */ });
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_app_events_lib_fireEvent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93415);
/* harmony import */ var _getClients__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52629);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function onSessionSaved(session) {
    return _onSessionSaved.apply(this, arguments);
};
function _onSessionSaved() {
    _onSessionSaved = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1(session) {
        var clients, promises;
        return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    clients = (0,_getClients__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
                    promises = Object.keys(clients).map(function() {
                        var _ref = _asyncToGenerator(_tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(clientName) {
                            var client;
                            return _tmp_build_80754af9_websites_repo_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.prev = 0;
                                        client = clients[clientName];
                                        _ctx.next = 4;
                                        return client.resetStore();
                                    case 4:
                                        _ctx.next = 6;
                                        return client.reFetchObservableQueries();
                                    case 6:
                                        if (client._wsClient) {
                                            // @ts-expect-error ts-migrate(2341) FIXME: Property 'tryReconnect' is private and only access... Remove this comment to see the full error message
                                            client._wsClient.tryReconnect();
                                        }
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.prev = 9;
                                        _ctx.t0 = _ctx["catch"](0);
                                        console.log("Error refetching apollo queries for client ".concat(clientName, ":"), _ctx.t0);
                                    case 12:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    9
                                ]
                            ]);
                        }));
                        return function(clientName) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx1.next = 4;
                    return Promise.all(promises);
                case 4:
                    (0,react_app_events_lib_fireEvent__WEBPACK_IMPORTED_MODULE_1__["default"])("saveSession", session || {});
                case 5:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    }));
    return _onSessionSaved.apply(this, arguments);
}


/***/ }),

/***/ 65160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ saveJWT; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./src/providers/apollo/getJWTData.ts
function getJWTData(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    var data = JSON.parse(jsonPayload).data;
    return data;
};

// EXTERNAL MODULE: ./src/providers/apollo/onSessionSaved.ts
var onSessionSaved = __webpack_require__(93307);
;// CONCATENATED MODULE: ./src/providers/apollo/saveJWT.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function saveJWT(_) {
    return _saveJWT.apply(this, arguments);
};
function _saveJWT() {
    _saveJWT = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var token, refreshToken, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    token = param.token, refreshToken = param.refreshToken;
                    if (token) {
                        _ctx.next = 8;
                        break;
                    }
                    localStorage.removeItem("justo_jwt_token");
                    localStorage.removeItem("justo_jwt_refresh");
                    localStorage.removeItem("justo_jwt_data");
                    _ctx.next = 7;
                    return (0,onSessionSaved/* default */.Z)(null);
                case 7:
                    return _ctx.abrupt("return");
                case 8:
                    localStorage.setItem("justo_jwt_token", token);
                    data = getJWTData(token);
                    localStorage.setItem("justo_jwt_data", JSON.stringify(data));
                    if (!refreshToken) {
                        _ctx.next = 16;
                        break;
                    }
                    localStorage.setItem("justo_jwt_refresh", refreshToken);
                    _ctx.next = 15;
                    return (0,onSessionSaved/* default */.Z)(data);
                case 15:
                    return _ctx.abrupt("return", _ctx.sent);
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _saveJWT.apply(this, arguments);
}


/***/ }),

/***/ 12719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getCustom; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(34155);
function getCustom(subdomain, forceProtocol) {
    if (!process.env.REACT_APP_DOMAIN) return;
    var protocol = forceProtocol || process.env.REACT_APP_USE_HTTP ? "http" : "https";
    return "".concat(protocol, "://").concat(subdomain, ".").concat(process.env.REACT_APP_DOMAIN);
};


/***/ }),

/***/ 4266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getEnv; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);
/* provided dependency */ var process = __webpack_require__(34155);

var hostname = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)() ? "" : window.location.hostname;
var isDev = hostname.includes("bejusto.com") || process.env.REACT_APP_DOMAIN;
var isLocal = hostname.endsWith(".local") || hostname.endsWith(".internal") || hostname.includes("localhost") || hostname.includes("100.1.20.187") || hostname.includes("192.168.") || hostname.includes(".ngrok.io") || hostname.includes("10.0.");
var isProduction = !isDev && !isLocal;
var forceProd = process.env.REACT_APP_FORCE_PRODUCTION;
function getEnv() {
    if (forceProd) return "prod";
    if (process.env.JUSTO_ENV) return process.env.JUSTO_ENV;
    if (isProduction) return "prod";
    return isDev ? "dev" : "local";
};


/***/ }),

/***/ 46842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ clientNames; }
/* harmony export */ });
/* harmony import */ var _providers_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65494);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68929);
/* harmony import */ var lodash_camelCase__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_camelCase__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3674);
/* harmony import */ var lodash_keys__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_keys__WEBPACK_IMPORTED_MODULE_2__);



var services = {
    main: {
        omitAuth: false,
        useSubscriptions: true,
        urls: {
            local: "http://localhost:3000",
            dev: _providers_url__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
            prod: "https://websites-api.getjusto.com"
        }
    },
    mainNoAuth: {
        omitAuth: true,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:3000",
            dev: _providers_url__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
            prod: "https://websites-api.getjusto.com"
        }
    },
    auth: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4112",
            dev: "https://auth.service.bejusto.com",
            prod: "https://auth.service.getjusto.com"
        }
    },
    example: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4100",
            dev: "https://example-orionjs.service.bejusto.com",
            prod: "https://example-orionjs.service.getjusto.com"
        }
    },
    buckets: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4106",
            dev: "https://buckets.service.bejusto.com",
            prod: "https://buckets.service.getjusto.com"
        }
    },
    reservations: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4113",
            dev: "https://reservations.service.bejusto.com",
            prod: "https://reservations.service.getjusto.com"
        }
    },
    data: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4107",
            dev: "https://data.service.bejusto.com",
            prod: "https://data.service.getjusto.com"
        }
    },
    finances: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4105",
            dev: "https://finances.service.bejusto.com",
            prod: "https://finances.service.getjusto.com"
        }
    },
    commander: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4109",
            dev: "https://commander.service.bejusto.com",
            prod: "https://commander.service.getjusto.com"
        }
    },
    linear: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4107/linear",
            dev: "https://data.service.bejusto.com/linear",
            prod: "https://data.service.getjusto.com/linear"
        }
    },
    "bank-transfers": {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4150",
            dev: "https://bank-transfers.service.bejusto.com",
            prod: "https://bank-transfers.service.getjusto.com"
        }
    },
    experiments: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4114",
            dev: "https://experiments.service.bejusto.com",
            prod: "https://experiments.service.getjusto.com"
        }
    },
    payments: {
        omitAuth: false,
        useSubscriptions: true,
        urls: {
            local: "http://localhost:4118",
            dev: "https://payments.service.bejusto.com",
            prod: "https://payments.service.getjusto.com"
        }
    },
    addresses: {
        omitAuth: false,
        useSubscriptions: false,
        urls: {
            local: "http://localhost:4051",
            dev: "https://addresses.service.bejusto.com",
            prod: "https://addresses.service.getjusto.com"
        }
    }
};
var clientNames = lodash_keys__WEBPACK_IMPORTED_MODULE_2___default()(services).reduce(function(acc, key) {
    acc[lodash_camelCase__WEBPACK_IMPORTED_MODULE_1___default()(key)] = key;
    return acc;
}, {});
/* harmony default export */ __webpack_exports__["Z"] = (services);


/***/ }),

/***/ 65494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getCustom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12719);
/* harmony import */ var _getEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4266);


var urls = {
    local: "http://localhost:3000",
    dev: "https://api.bejusto.com",
    prod: "https://websites-api.getjusto.com"
};
var env = (0,_getEnv__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
/* harmony default export */ __webpack_exports__["Z"] = ((0,_getCustom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("api") || urls[env]);


/***/ }),

/***/ 80967:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
const react_1 = __webpack_require__(67294);
const store_1 = __webpack_require__(3496);
function useOnEvent(name, func, differs = null) {
    (0, react_1.useEffect)(() => {
        (0, store_1.addListener)(name, func);
        return () => {
            (0, store_1.removeListener)(name, func);
        };
    }, differs);
}
exports["default"] = useOnEvent;
//# sourceMappingURL=useOnEvent.js.map

/***/ })

}]);